import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData"],
  data() {
    return {
      options: {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display:  true
				},
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function(tooltipItems, data) {
							let nStr = Math.round(tooltipItems.yLabel).toString()
							let x = nStr.split('.');
							let x1 = x[0];
							let x2 = x.length > 1 ? '.' + x[1] : '';
							var rgx = /(\d+)(\d{3})/;
							while (rgx.test(x1)) {
								x1 = x1.replace(rgx, '$1' + '.' + '$2');
							}
							return x1 + x2;
						}
					}
				},
				responsive: true,
				maintainAspectRatio: false,
				height: 200
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
